import { Component } from '@angular/core';

@Component({
  selector: 'app-call-to-action-section',
  standalone: true,
  imports: [],
  templateUrl: './call-to-action-section.component.html',
  styleUrl: './call-to-action-section.component.scss'
})
export class CallToActionSectionComponent {

}
